import { render } from "./colleagueFinder.vue?vue&type=template&id=03052b20"
import script from "./colleagueFinder.vue?vue&type=script&lang=js"
export * from "./colleagueFinder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__